module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/VG1005-5cd82d14428ab6b2848ee8d2b8740ded.png";